export default __webpack_public_path__ + "static/media/t6.544fd361.png";